import React, { useEffect, useState } from 'react'

import TutorSidebar from '../../TutorSidebar/TutorSidebar'
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getBrowsStudentRequestedDetailData } from '../../../../Redux/action/TutorAction'
import Beatloader from '../../../../Common/BeatLoader'
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import HourglassLoader from '../../../../Common/HourglassLoader'

const host = process.env.REACT_APP_API_SERVER
const TutorMySession = () => {
    const dispatch = useDispatch();
    // const navigate = useDispatch();
    const navigate = useNavigate();
    const { b64id } = useParams();
    const [requestId, setRequestId] = useState(null);
    const [showModal, setShowModal] = useState();
    const location = useLocation();
    const BrowseStudentRequestedDetailApiData = location.state.data
    console.log(BrowseStudentRequestedDetailApiData)
    useEffect(() => {
        try {

            const requestId = atob(b64id);

            if (!requestId || isNaN(requestId)) {
                throw new Error("Invalid course ID");
            }
            else {
                setRequestId(requestId)
            }

            // dispatch(getBrowsStudentRequestedDetailData(requestId))
        } catch (error) {

            navigate(-1);
        }
    }, [b64id]);


    const {
        loadingBrowseStudentRequestedDetailApi,
        // BrowseStudentRequestedDetailApiData,
        BrowseStudentRequestedDetailApiError
    } = useSelector(state => state?.TutorReducer);

    // useEffect(() => {
    //     if (BrowseStudentRequestedDetailApiError) {
    //         navigate('/tutor/dashboard')
    //     }
    // }, [BrowseStudentRequestedDetailApiError])

    const formik = useFormik({
        initialValues: {
            request_id: requestId,
            rejected_reason: '',
        },
        validationSchema: Yup.object().shape({
            rejected_reason: Yup.string().required("Disapproval reason is required"),
        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            try {
                const config = {
                    headers: {
                        "x-auth-token": localStorage.getItem('tutor-token'), // Custom header with the token
                    },
                }
                values.request_id = requestId
                const response = await axios.post(`${host}/api/tutor/requested-tutor/disapprove`, values, config)

                if (response.status == 200) {
                    setSubmitting(false)
                    setShowModal(false)
                    toast.success(response.data.message);

                    resetForm();
                    navigate('/tutor/dashboard')


                } else {
                    console.log('else', response)
                    setSubmitting(false)

                    toast.error(response.data.message);

                }

            } catch (error) {

                console.log(error)
                setSubmitting(false)
                toast.error(error.response.data.message);

            }
        }
    });


    return (
        <div >

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;My Session
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                {loadingBrowseStudentRequestedDetailApi ?
                                    <Beatloader />
                                    :
                                    <div className="my-schedule-detail-sec">
                                        <div className="row">
                                            <div className="col-lg-2">
                                                <img src={`${host}${BrowseStudentRequestedDetailApiData?.student?.profile_img}`} className="img-fluid w-auto" onError={(e) => {
                                                    e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                }} />
                                            </div>
                                            <div className="col-lg-7">
                                                <h4 className="mb-0 mt-4 fw-bold">{BrowseStudentRequestedDetailApiData?.student?.name}</h4>
                                                <p className="mb-0 text-primary fw-bold">{BrowseStudentRequestedDetailApiData?.reqChildSubCategory?.name}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0 mt-2 fw-bold">
                                                    <i className="fa-solid fa-calendar-days" /> Scheduled Date
                                                </p>
                                                <p className="mb-0 ms-4 text-primary fw-bold">{BrowseStudentRequestedDetailApiData?.format_start_date}</p>
                                            </div>
                                        </div>
                                        <div className="row mt-4 mb-3">
                                            <div className="col-lg-3">
                                                <p className="mb-0">Class/Grade/General</p>
                                                <p className="mb-0 fw-bold">{BrowseStudentRequestedDetailApiData?.reqCategory?.name}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0">Subject</p>
                                                <p className="mb-0 fw-bold">{BrowseStudentRequestedDetailApiData?.reqSubCategory?.name}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0">Module</p>
                                                <p className="mb-0 fw-bold">{BrowseStudentRequestedDetailApiData?.reqChildSubCategory?.name}</p>
                                            </div>
                                        </div>
                                        <div className="row mb-4">
                                            <div className="col-lg-3">
                                                <p className="mb-0">Start date</p>
                                                <p className="mb-0 fw-bold text-primary">{BrowseStudentRequestedDetailApiData?.format_start_date}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0">End date</p>
                                                <p className="mb-0 fw-bold text-primary">{BrowseStudentRequestedDetailApiData?.format_end_date}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0">Timing</p>
                                                <p className="mb-0 fw-bold text-primary">{BrowseStudentRequestedDetailApiData?.time_slot?.formated_start_end_time} ({BrowseStudentRequestedDetailApiData?.time_slot?.timeZoneAbb}) </p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0">Created at</p>
                                                <p className="mb-0 fw-bold text-primary">{BrowseStudentRequestedDetailApiData?.createdAt ? BrowseStudentRequestedDetailApiData?.createdAt?.split(" ")?.[0] : ''}</p>
                                            </div>
                                            <div className="col-lg-12 mt-3">
                                                <p className="mb-0">Topic Details</p>
                                                <p className="mb-0  text-primary">{BrowseStudentRequestedDetailApiData?.topic_details}</p>
                                            </div>
                                        </div>
                                        {BrowseStudentRequestedDetailApiData?.status == 'PENDING' &&
                                            <div className="row my-4">
                                                {/* <div className="col-lg-4 col-md-6 mb-3">
                                                    <Link to={`/tutor/create-new-session/${btoa(requestId)}`} state={{data:BrowseStudentRequestedDetailApiData}} >
                                                        <button className="btn btn-primary w-100">
                                                            Approve &amp; Create Session
                                                        </button>
                                                    </Link>
                                                </div> */}
                                                <div className="col-lg-4 col-md-6 mb-3">
                                                    <button
                                                        className="btn btn-primary w-100"
                                                        onClick={async () => {
                                                            try {
                                                                const config = {
                                                                    headers: {
                                                                        "x-auth-token": localStorage.getItem("tutor-token")
                                                                    }
                                                                };

                                                                const values = { request_id: requestId };

                                                                const response = await axios.post(`${host}/api/tutor/requested-tutor/approve`, values, config);

                                                                if (response.status === 200) {
                                                                    toast.success(response.data.message);

                                                                    navigate(`/tutor/create-new-session/${btoa(requestId)}`, {
                                                                        state: { data: BrowseStudentRequestedDetailApiData }
                                                                    });
                                                                }
                                                            } catch (err) {
                                                                console.error(err);
                                                                toast.error(err.response?.data?.message || "Something went wrong");
                                                            }
                                                        }}
                                                    >
                                                        Approve & Create Session
                                                    </button>
                                                </div>

                                                <div className="col-lg-4 col-md-6 mb-3">
                                                    <button
                                                        className="btn btn-outline-primary w-100"
                                                        onClick={() => { setShowModal(true) }}
                                                    >
                                                        Disapprove
                                                    </button>
                                                </div>
                                            </div>}
                                    </div>
                                }
                            </main>

                        </div>
                    </div>
                </div>
            </section>
            <>
                {/* Disapprove Modal */}

                <Modal className='tutor-my-session' show={showModal} onHide={() => setShowModal(false)}>

                    <form onSubmit={formik.handleSubmit} method='post'>
                        <Modal.Header closeButton className='border-0'>

                        </Modal.Header>
                        <Modal.Body>
                            <h5 className="text-center">Are you sure ?</h5>
                            <p className="text-center">You want to disapprove this student.</p>
                            <input
                                type="text"
                                className="w-100 px-2 py-3 modal-input"
                                placeholder="Please enter reason*"
                                name='rejected_reason'
                                value={formik.values.rejected_reason}
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                            />
                            <div className="help-block with-errors">
                                {formik.touched.rejected_reason && formik.errors.rejected_reason ? (
                                    <div className='text-danger'>{formik.errors.rejected_reason}</div>
                                ) : null}
                            </div>
                        </Modal.Body>
                        <Modal.Footer className='border-0'>
                            <div className="row w-100">
                                <div className="col-lg-6 mb-3">
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary w-100"
                                        onClick={() => { setShowModal(false) }}
                                    >
                                        Close
                                    </button>
                                </div>
                                <div className="col-lg-6 mb-3">

                                    <button type="submit" disabled={formik.isSubmitting} className="btn btn-primary w-100">
                                        {formik.isSubmitting ? <HourglassLoader /> : 'Continue'}

                                    </button>

                                </div>
                            </div>
                        </Modal.Footer>
                    </form>

                </Modal>
            </>

        </div>
    )
}

export default TutorMySession